/**
 * CreateTableDialog - Dialog para criar nova tabela de comissão
 */
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../ui/dialog";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/select";

export function CreateTableDialog({
  open,
  onOpenChange,
  novaTabela,
  setNovaTabela,
  bancos,
  instituicoes,
  tiposOperacao,
  correspondentes,
  onCriarTabela
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Criar Nova Tabela de Comissão</DialogTitle>
          <DialogDescription>
            Defina a vinculação da tabela com Banco, Instituição e Tipo de Operação
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Banco *</Label>
            <Select 
              value={novaTabela.banco_id} 
              onValueChange={(v) => setNovaTabela({ ...novaTabela, banco_id: v, instituicao: "" })}
            >
              <SelectTrigger data-testid="select-banco-nova-tabela">
                <SelectValue placeholder="Selecione o banco" />
              </SelectTrigger>
              <SelectContent>
                {bancos.map(banco => (
                  <SelectItem key={banco.id} value={banco.id}>
                    {banco.codigo} - {banco.nome}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          
          <div className="space-y-2">
            <Label>Instituição</Label>
            <Select 
              value={novaTabela.instituicao || "__all__"} 
              onValueChange={(v) => setNovaTabela({ ...novaTabela, instituicao: v === "__all__" ? "" : v })}
            >
              <SelectTrigger data-testid="select-instituicao-nova-tabela">
                <SelectValue placeholder="Selecione a instituição (opcional)" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="__all__">Todas (Geral)</SelectItem>
                {instituicoes.map((inst, idx) => (
                  <SelectItem key={`inst-${idx}`} value={inst}>{inst}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          
          <div className="space-y-2">
            <Label>Tipo de Operação *</Label>
            <Select 
              value={novaTabela.tipo_operacao} 
              onValueChange={(v) => setNovaTabela({ ...novaTabela, tipo_operacao: v, nome: v })}
            >
              <SelectTrigger data-testid="select-tipo-operacao-nova-tabela">
                <SelectValue placeholder="Selecione o tipo" />
              </SelectTrigger>
              <SelectContent>
                {tiposOperacao.map((tipo, idx) => (
                  <SelectItem key={`tipo-${idx}`} value={tipo}>{tipo}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          
          <div className="space-y-2">
            <Label>Correspondente</Label>
            <Select 
              value={novaTabela.correspondente || "__all__"} 
              onValueChange={(v) => setNovaTabela({ ...novaTabela, correspondente: v === "__all__" ? "" : v })}
            >
              <SelectTrigger data-testid="select-correspondente-nova-tabela">
                <SelectValue placeholder="Selecione o correspondente (opcional)" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="__all__">Todos (Geral)</SelectItem>
                {correspondentes.map((corresp, idx) => (
                  <SelectItem key={`corresp-${idx}`} value={corresp}>{corresp}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button 
            onClick={onCriarTabela} 
            className="bg-emerald-600 hover:bg-emerald-700"
            data-testid="btn-confirmar-criar-tabela"
          >
            Criar Tabela
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
